import React, { useState, useEffect } from "react";
import styles from "./Unsubscribe.module.scss";
import PaymentService from "../../../sevices2/paymentServices";
import { Unsubscribe } from "@mui/icons-material";

const UnsubscribeModal = ({ pfp, channel, access, channelID, closeModal }) => {
  const [step, setStep] = useState(1);
  const [clientSecret, setClientSecret] = useState("");

  const unsubscribe = () => {
    PaymentService.deleteSubscription(access, channelID)
      .then(closeModal())
  };

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <>
      {step === 1 && (
        <div className={styles.blurBackground}>
          <div className={styles.container}>
            <div className={styles.header}>
              <button className={styles.closeModalButton} onClick={closeModal}>
                X
              </button>
              <h3 style={{ margin: "0 0 0 0", fontSize: "20pt" }}>
                Unsubscribe Confirmation
              </h3>
            </div>
            <img src={pfp} alt="channel-thumbnail" className={styles.pfp} />
            <h3 className={styles.channelName}>{channel}</h3>
            <div className={styles.gridContainer}>
              <h3 className={styles.spanTwoColumns}>
                By Unsubscribing, You Will Lose:
              </h3>
              <div className={styles.gridItem}>
                <div className={styles.exclusive}></div>
                <p className={styles.descriptions}>Exclusive Content</p>
              </div>
              <div className={styles.gridItem}>
                <div className={styles.support}></div>
                <p className={styles.descriptions}>Support the Creator</p>
              </div>
              <div className={styles.gridItem}>
                <div className={styles.badge}></div>
                <p className={styles.descriptions}>Subscriber Badge</p>
              </div>
              <div className={styles.gridItem}>
                <div className={styles.chatBubble}></div>
                <p className={styles.descriptions}>Chat During Sub Mode</p>
              </div>
            </div>
            <h3 className={styles.subscriptionPrice}>
              Are You Sure You Want To Unsubscribe?
            </h3>
            <div className={styles.row}>
              <button className={styles.subscribeButton} onClick={unsubscribe}>
                Yes
              </button>
              <button
                className={styles.staySubscribedButton}
                onClick={() => closeModal()}
              >
                Stay Subscribed
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UnsubscribeModal;
